import React, { useEffect, useState } from 'react';
import { CardProductCodeName, CardProductTabName } from '../../constants/Card';
import CardContainerContent from 'views/Main/CardContainerContent';
import { getVersionUrl } from 'common/cacheOverwrite';

type Props = {
  cardInfo: CardInfo;
}

const CardApplyContainer: React.FC<Props> = ({ cardInfo }) => {

  const { cardProductCode, cashYn, canApplyImgUrlList = [] } = cardInfo;
  const cashable: boolean = cashYn.toUpperCase() === 'Y';

  const [flipped, setFlipped] = useState(false);

  useEffect(() => {
    let interval: NodeJS.Timer;
    if (canApplyImgUrlList.length > 1) {
      interval = setInterval(() => {
        setFlipped((prev) => !prev);
      }, 3000); // 3초마다 뒤집힘
    }
    return () => clearInterval(interval);
  }, [canApplyImgUrlList]);

  return (
    <div className="cardWrap3 flip">
      <div className={`img ${flipped ? 'flipped' : ''}`.trim()}>
        <img className={'card-front'} src={getVersionUrl(`${canApplyImgUrlList[0]}`)}
             alt={CardProductCodeName[Number(cardProductCode)]}
        />
        {
          canApplyImgUrlList.length > 1
          && (<img className={'card-back'} src={getVersionUrl(`${canApplyImgUrlList[1]}`)}
                   alt={CardProductCodeName[Number(cardProductCode)]}
          />)
        }
      </div>
      <section>
        <div className={`cardTitle ${cashable ? 'atmTitle' : ''}`.trim()}>
          {`${CardProductTabName[Number(cardProductCode)]} ${cashable ? 'ATM+' : 'Card'}`}
        </div>
        <CardContainerContent cardInfo={cardInfo} />
      </section>
    </div>
  );
};

export default CardApplyContainer;
